import { render, staticRenderFns } from "./PricePoint.template.vue?vue&type=template&id=4e6e96e0&scoped=true&"
var script = {}
import style0 from "./PricePoint.template.vue?vue&type=style&index=0&id=4e6e96e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6e96e0",
  null
  
)

export default component.exports